import dayjs from "dayjs";
import {
  CloserAvailabilityHourGroup,
  CloserAvailabilityNormalizedSlot,
} from "./createCloserAvailabilityCalendarMap.ts";

function getColorClass(count: number): string {
  if (count === 0) return "bg-red-100 text-red-700";
  if (count <= 2) return "bg-amber-100 text-amber-700";
  return "bg-green-100 text-green-700";
}

export function CloserAvailabilityCalendarSlotItem({
  group,
  onClick,
}: {
  group: CloserAvailabilityHourGroup;
  onClick: (slot: CloserAvailabilityNormalizedSlot) => void;
}) {
  return (
    <div className="flex flex-col gap-0.5">
      {group.slots.map((slot, i) => (
        <div
          key={i}
          onClick={(e) => {
            e.stopPropagation();
            onClick(slot);
          }}
          className={`rounded px-1.5 py-2 text-xs cursor-pointer hover:opacity-75 flex items-center justify-between gap-1 ${getColorClass(slot.availableUsers.length)}`}
        >
          <span className="font-medium tabular-nums">
            {dayjs(slot.slotStart).format("HH:mm")}–
            {dayjs(slot.slotEnd).format("HH:mm")}
          </span>
          <span className="flex items-center gap-1 tabular-nums">
            <span className="font-semibold">{slot.availableUsers.length}</span>
            <span className="opacity-30">·</span>
            <span className="font-medium text-blue-600">
              {slot.busyWorkUsers?.length ?? 0}
            </span>
            <span className="opacity-30">·</span>
            <span className="font-medium text-gray-500">
              {slot.busyOooUsers?.length ?? 0}
            </span>
          </span>
        </div>
      ))}
    </div>
  );
}
